import { FieldProps, getIn } from 'formik'

import SelectField, {
    SelectFieldProps,
} from '@totallymoney/ui/components/SelectField'
import ChevronDown from '@totallymoney/ui/icons/ChevronDown'
import theme from '@totallymoney/ui/theme'

type FormikSelectFieldProps<Value> = FieldProps<Value> &
    SelectFieldProps & {
        options: { label: string; value: any }[]
        placeholder?: string
    }

function FormikSelectField<
    Value extends string | number | readonly string[] | undefined = any,
>({
    helperText,
    placeholder,
    options,
    field,
    form: { touched, errors },
    ...rest
}: FormikSelectFieldProps<Value>) {
    const isFieldTouched = getIn(touched, field.name) as boolean
    const validationMessage = getIn(errors, field.name) as string

    return (
        <SelectField
            helperText={helperText}
            icon={<ChevronDown size={14} color={theme.indigo60} />}
            validationMessage={validationMessage}
            touched={isFieldTouched}
            {...field}
            {...rest}
        >
            {!!placeholder && (
                <option value="" disabled>
                    {placeholder}
                </option>
            )}

            {options.map(({ label, value }, index) => (
                <option key={`${field.name}-${index + 1}`} value={value}>
                    {label}
                </option>
            ))}
        </SelectField>
    )
}

export default FormikSelectField
